module.exports = new __parcel__URL__("faq_button_to_close.6fb96ea5.webp").toString();